export const DASHBOARD_TYPES = {
  // V1 portal -> V1 dashboard. `fdAnalytics` now maps to the V2 dashboard in the
  // analytics lambda, so this branch must ask for the V1 one explicitly.
  FD_ANALYTICS_V1: "fdAnalyticsV1",
  FD_LEAD_RETRIEVAL_ANALYTICS: "fdLRAnalytics",
};